// src/pages/HomePage.jsx
import React, { useState } from "react";
import Header from "../components/Header.jsx";
import ImageBanner from "../components/ImageBanner.jsx";
import DonationHighlights from "../components/DonationHighlights.jsx";
import ImpactSection from "../components/ImpactSection.jsx";
import Footer from "../components/Footer.jsx";
import AboutSection from "../components/AboutSection.jsx";
import { useDonate } from "../contexts/DonateContext";

export default function HomePage() {
  // Local preselect UI only (optional). The modal state & submission live in the Provider.
  const [donationAmount, setDonationAmount] = useState(25);
  const [dedicatedTo, setDedicatedTo] = useState("");

  const { openDonate, refreshTick } = useDonate();

  return (
    <>
      <Header />

      <ImageBanner
        setDonationAmount={setDonationAmount}
        donationAmount={donationAmount}
        setDedicatedTo={setDedicatedTo}
        openDonationModal={() =>
          openDonate({
            amount: donationAmount,
            honoree: dedicatedTo,
            startOnContact: true,
          })
        }
        setStartOnContact={() => {}}
      />

      <DonationHighlights refreshKey={refreshTick} />

      <AboutSection />

      <ImpactSection
        onDonate={() =>
          openDonate({
            amount: donationAmount,
            startOnContact: false,
          })
        }
      />

      <Footer />
    </>
  );
}
